import {
  primaryColor,
  successColor,
  dangerColor,
  warningColor,
  grayColor
} from "assets/jss/material-dashboard-pro-react.js";

const royaltyRowStyle = {
  row: {
    alignItems: "center",
    padding: "6px 12px",
    borderRadius: "3px",
    marginBottom: "2px"
  },
  label: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "right",
    fontSize: "13px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: grayColor[7],
    "@media (max-width: 599px)": {
      justifyContent: "flex-start",
      textAlign: "left"
    }
  },
  value: {
    display: "block",
    fontSize: "18px",
    color: grayColor[1]
  },
  sub: {
    display: "block",
    fontSize: "12px",
    color: grayColor[0]
  },
  emphasis: {
    fontWeight: 500,
    fontSize: "20px"
  },
  large: {
    fontWeight: 500,
    fontSize: "24px"
  },
  positive: {
    color: successColor[0] + " !important"
  },
  negative: {
    color: dangerColor[0] + " !important"
  },
  highlight: {
    background: grayColor[12]
  },
  highlightPositive: {
    background: "#edf7ee"
  },
  highlightNegative: {
    background: "#fdeeee"
  },
  groupTitle: {
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: ".1em",
    color: primaryColor[0],
    padding: "0 0 10px",
    borderBottom: "1px solid #ece6f1",
    margin: "18px 0 8px"
  },
  ruleBadge: {
    display: "inline-block",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: ".06em",
    padding: "7px 10px",
    borderRadius: "3px",
    textTransform: "uppercase"
  },
  ruleBadgeV2: {
    background: "#f3edf8",
    color: primaryColor[0]
  },
  ruleBadgeLegacy: {
    background: grayColor[8],
    color: grayColor[6]
  },
  warningBox: {
    display: "flex",
    gap: "8px",
    background: "#fff6e8",
    border: "1px solid " + warningColor[0],
    color: "#7a4a06",
    borderRadius: "4px",
    padding: "10px 12px",
    fontSize: "13px",
    lineHeight: 1.4,
    marginTop: "8px"
  },
  memoryToggle: {
    color: primaryColor[0],
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    padding: "8px 0",
    background: "none",
    border: "none"
  },
  memoryBox: {
    background: "#f7f5f9",
    border: "1px solid #e3dcea",
    borderRadius: "4px",
    padding: "16px 18px"
  },
  memoryLine: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "16px",
    fontFamily: "'Roboto Mono', monospace",
    fontSize: "13px",
    lineHeight: 1.5,
    color: grayColor[6],
    "& span:last-child": {
      fontWeight: 500
    }
  }
};

export default royaltyRowStyle;
